module.exports = __webpack_public_path__ + "static/media/vf_mouter_core.69f7452c.svg";